import React from "react";

//Leiaute terceiros
import { Theme, Box, Paper, Divider } from "@mui/material";
import { makeStyles } from 'tss-react/mui';

//Leiaute Interno

import Alert from "../alerts/Alerts";
import BackDrop from "../backdropLoading/viewLoadingBackDrop"
import ShowDialog from "../showDialog";
import {ToolbarCad} from "../toolbar";
import { FormCadProps,FormCad } from "./formCad"

import { getKeyValue } from "../../services/utils"


//const height = window.innerHeight;//pega a altura da tela

const useStyles = makeStyles()((theme:Theme)=>({
    root: {
        display:"flex",
        flexGrow:1,
        height: '100%',
      },
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    boxListShowLeiaute:{
        display:'none',
        [theme.breakpoints.down('sm')]:{
            display:'block'
        }
    },
    boxTableShowLeiaute:{
        display:'none',
        [theme.breakpoints.up('md')]:{
            display:'flex',
            flex:1,
        }
    },
    boxListShowFixo:{
        display:'flex',
        flex:1,
    },
    boxTableHideFixo:{
        display:'none',
    }
      
}))

interface WindowsCadProps {
    status:string;
    title:string;
    subtitle?:string;
    showAlert:boolean;
    msg:string;
    handleCloseAlert:()=>void;
    row:any;
    fieldDescription:string;
    openDialogExcluir:boolean;
    handleExcluir:()=>void;
    handleCloseDialogExcluir:()=>void;
    handleCloseForm?:()=>void;
    loading:boolean;
    buttonNovo:{
        show:boolean,
        onClick:()=>void;
        title:string;
    }    
}


export interface PropsViewCad extends WindowsCadProps{
    formCad:FormCadProps;
}

export function ViewCad (props:PropsViewCad) {
    const { 
        status,
        showAlert,
        fieldDescription,
        handleCloseAlert,
        handleCloseDialogExcluir,
        handleExcluir,
        loading,
        openDialogExcluir,
        row,
        title,
        subtitle,
        handleCloseForm,
        msg,
        buttonNovo,
        formCad
    } = props;
    const {classes} = useStyles();

    return (
        <Box sx={{display:"flex",flex:1, flexDirection:"column",height:'inherit'}}>
            <Alert show={showAlert} menssage={msg} tipoAlerta={status==="error"?"error":"success"} handleClose={handleCloseAlert} />
            <BackDrop showLoading={loading} backdropInvisible={false} msg={msg} />
            <ShowDialog
                title={"Excluir "+title}
                msg={
                    "Você confirma a exclusão do(a) "+title +" "+
                    getKeyValue(row,fieldDescription) +
                    " ?"
                }
                close={handleCloseDialogExcluir}
                ok={handleExcluir}
                open={openDialogExcluir}
            /> 

            <ToolbarCad 
                handleBack={handleCloseForm}
                title={title}
                subtitle={subtitle}
                color={"inherit"}
                positionToolBar={"relative"}
                variantToobar={"dense"}
                buttonNovo={buttonNovo}
                elevation={1}
            />    
            <Divider  />        
            {/* Container */}             
            <Box
                sx={{
                    flexDirection: "column",
                    display: "flex",
                    flexGrow: 1,
                    padingTop:1,
                    height:'100%',
                    overflow:'auto',
                }}
            >
                <FormCad 
                    contentForm={formCad.contentForm}
                    row={formCad.row}
                    handleCancel={formCad.handleCancel}
                    handleOnSubmit={formCad.handleOnSubmit}
                    handleMutator={formCad.handleMutator}
                    buttonActions={formCad.buttonActions}
                    formValidation={formCad.formValidation}
                    ContentBox={formCad.ContentBox}
                />
            </Box>   

        </Box>


 

             

    )
}